import { AuthService } from "@/services/auth.service";
import router from "@/router";
import axiosModule from "@/util/axios-module";

const state = {
  token: "",
  user: null,
  theme: {},
  guestUser: null,
  message: {},
  updateUser: "",
  password: "",
  resetPassword: "",
  cancelRecurringPlan: null,
};
const getters = {
  isAuthenticated() {
    return localStorage.getItem("access_token") != null;
  },
  joinedUser(state) {
    return state.user;
  },
  getTheme: (state) => {
    return state.theme;
  },
  isTrialUser(state) {
    return state.user && state.user.client.plan.id === 1;
  },
  trialDaysLeft(state) {
    return state.trialDaysLeft;
  },
  trialExpired(state) {
    return state.trialExpired;
  },
  guestUser(state) {
    return state.guestUser;
  },
  getMessage(state) {
    return state.message;
  },
  getUpdateUser(state) {
    return state.updateUser;
  },
  getCancelRecurringPlan(state) {
    return state.cancelRecurringPlan;
  },
};
const mutations = {
  setToken(state, value) {
    state.token = value;
  },
  setRecurringPlan(state, value) {
    state.cancelRecurringPlan = value;
  },
  setMessage(state, value) {
    state.message = value;
  },
  setUser(state, value) {
    state.user = value;
  },
  setTheme(state, theme) {
    localStorage.setItem("theme", theme);
    if (theme == "system") {
      const userPrefersDark = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;
      state.theme = userPrefersDark ? "dark" : "light";
    } else {
      state.theme = theme;
    }

    if (state.theme === "light") {
      document.querySelector("html").classList.remove("dark");
    } else {
      document.querySelector("html").classList.add("dark");
    }
  },
  setGuestUser(state, value) {
    state.guestUser = value;
  },
  setUpdateUser(state, value) {
    state.updateUser = value;
  },
  setChangePassword(state, value) {
    state.password = value;
  },
  setResetPassword(state, value) {
    state.resetPassword = value;
  },
  setCancelRecurringPlan(state, value) {
    state.cancelRecurringPlan = value;
  },
};
const actions = {
  emitGuestUser({ commit }, val) {
    commit("setGuestUser", val);
  },
  controlMaintenance({ commit }) {
    return new Promise((resolve) => {
      AuthService.isMaintenance("TopMessage").then((r) => {
        commit("setMessage", r.data.result);
        resolve(r.data.result);
      });
    });
  },
  login({ commit, dispatch }, credentials) {
    return new Promise((resolve, reject) => {
      AuthService.Login(credentials)
        .then((r) => {
          const token = r.data.result.accessToken;
          localStorage.setItem("access_token", token);
          commit("setToken", token);
          dispatch("initAuth");
          resolve(token);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  startTrial({ commit, dispatch }, user) {
    return new Promise((resolve, reject) => {
      AuthService.RegisterUser(user)
        .then((r) => {
          commit("setIsWelcomeShowed", false);
          commit("setIsDeviceLaunchTourShowed", false);
          resolve(r);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  changePassword({ commit }, args) {
    return new Promise((resolve, reject) => {
      axiosModule
        .post("/users/updatePassword", args)
        .then((response) => {
          commit("setChangePassword", response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  initAuth({ commit, dispatch }) {
    const token = localStorage.getItem("access_token");
    dispatch("emitShowTourInfo");
    if (token) {
      commit("setToken", token);
      AuthService.FetchUser()
        .then((r) => {
          commit("setUser", r.data.result);
        })
        .catch((error) => {
          throw new Error(error);
        });
    } else {
      // dispatch("logout");
    }
  },
  initTheme({ commit }, selectedTheme) {
    const storedTheme = localStorage.getItem("theme") ?? "system";
    if (selectedTheme === undefined) {
      commit("setTheme", storedTheme);
    } else {
      commit("setTheme", selectedTheme);
    }
  },
  logout({ commit }) {
    localStorage.removeItem("access_token");
    sessionStorage.clear();
    commit("setToken", "");
    if (router.currentRoute.path !== "/login") {
      router.push({ name: "Login" }).then(() => {});
    }
  },
  // eslint-disable-next-line no-unused-vars
  forgotPassword({ commit, dispatch }, value) {
    return new Promise((resolve, reject) => {
      AuthService.ForgotPassword(value)
        .then((r) => {
          resolve(r);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  updateUser({ commit }, args) {
    return new Promise((resolve, reject) => {
      AuthService.UpdateUser(args)
        .then((response) => {
          commit("setUpdateUser", response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  resetPassword({ commit }, args) {
    return new Promise((resolve, reject) => {
      AuthService.ResetPassword(args)
        .then((response) => {
          commit("setResetPassword", response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  cancelRecurringPlan({ commit }, args) {
    return new Promise((resolve, reject) => {
      axiosModule
        .post(`/checkout/cancelRecurringPlan?recurringPlanCode=${args}`)
        .then((response) => {
          commit("setRecurringPlan", response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
};
